import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalSyncReaderConnectionStatusError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalSyncReaderConnectionStatusError';
  }
}
